// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/Tabs/Comms/mutationDiscussion.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Patients_Content_Content_Sections_Tabs_Comms(
  $resource: comms_thread_internal_resource!
  $thread_name: String!
  $parent_company_id: uuid!
) {
  thread: comms_threads_internal_resource_create(
    resource: $resource
    thread_name: $thread_name
    parent_company_id: $parent_company_id
  ) {
    id
    status
  }
}

`